<template>
	<BModal id="credit-card-modal"
		centered
		size="md"
		title="Enter your Credit Card Details">
		<p class="text-muted">
			We will only charge you after your clean has been completed.
		</p>
		<div class="mb-4"></div>
		<credit-card-form
			ref="creditCardForm"
			:country="user.country" />
		<BAlert variant="danger" :model-value="stripe_errors !== null"
			class="mt-2">
			{{ stripe_errors }}
		</BAlert>
		<template #footer>
			<div class="d-flex justify-content-between gap flex-grow-1 align-items-center">
				<div>
					<img src="/assets/img/powered-by-stripe.svg" style="height: 24px;" />
				</div>
				<div>
					<BButton variant="light" @click="$bvModal.hide('credit-card-modal')">
						Cancel
					</BButton>
					<BButton variant="primary" :disabled="submitting"
						@click="submit">
						<BSpinner v-if="submitting" small
							class="mr-2"></BSpinner>
						Save Card
					</BButton>
				</div>
			</div>
		</template>
	</BModal>
</template>

<script>
	import { useValidation } from '@js/composables/useValidation.js';
	import { mapGetters } from 'vuex';
	import CreditCardForm from '@js/components/my/client/CreditCardForm.vue';

	export default {
		components: {
			CreditCardForm
		},
		emits: ['card-updated'],
		setup() {
			return {
				...useValidation(),
			};
		},
		data() {
			return {
				error: null,
				stripe_errors: null,
				submitting: false,
			}
		},
		computed: {
			...mapGetters({
				user: 'auth/user',
			}),
		},
		methods: {
			async submit() {
				this.stripe_errors = null;
				this.submitting = true;

				try {
					const token = await this.$refs.creditCardForm.createToken();

					if (!token) {
						this.submitting = false;
						this.$bvToast.toast('An error occurred while updating your credit card details.', {
							title: 'Error',
							variant: 'danger',
							solid: true,
						});
						return;
					}

					await this.$axios.post('/api/account/update-card-and-convert-all-bookings', {
						token: token,
					});

					this.$bvToast.toast('Your credit card details have been updated.', {
						title: 'Success',
						variant: 'success',
						solid: true,
					});
					this.$bvModal.hide('credit-card-modal');
					this.$emit('card-updated');

				} catch (error) {
					this.handleError(error);

					if (error?.response?.data?.status === false) {
						this.stripe_errors = error.response.data.errors;
					}
				} finally {
					this.submitting = false;
				}
			}
		}
	}
</script>
